// Cloudflare Turnstile site key — public, safe to ship in client bundle.
// Secret key lives in TURNSTILE_SECRET_KEY env var (server-only).
export const TURNSTILE_SITE_KEY = "0x4AAAAAADIrLynYZZ9zkbZr";

const VERIFY_URL = "https://challenges.cloudflare.com/turnstile/v0/siteverify";

/**
 * Verify a Turnstile token server-side. Throws if invalid.
 * Call this at the top of any server function that accepts a turnstileToken.
 */
export async function verifyTurnstileToken(token: string, remoteIp?: string | null): Promise<void> {
  const secret = process.env.TURNSTILE_SECRET_KEY;
  if (!secret) {
    // Fail closed so we don't silently bypass CAPTCHA in prod if the secret is missing.
    throw new Error("CAPTCHA verification is unavailable. Please try again later.");
  }
  if (!token || typeof token !== "string") {
    throw new Error("Please complete the CAPTCHA challenge.");
  }

  const body = new URLSearchParams({ secret, response: token });
  if (remoteIp) body.set("remoteip", remoteIp);

  let result: { success: boolean; "error-codes"?: string[] };
  try {
    const res = await fetch(VERIFY_URL, { method: "POST", body });
    result = (await res.json()) as typeof result;
  } catch {
    throw new Error("Could not verify CAPTCHA. Please try again.");
  }

  if (!result.success) {
    throw new Error("CAPTCHA verification failed. Please refresh and try again.");
  }
}
